const en = {
  Dashboard: 'Dashboard',
  Catalog: 'Catalog',
  Catalogs: 'Catalogs',
  Quotes: 'Quotes',
  Clients: 'Clients',
  Management: 'Management',
  Docs: 'Docs',
  Tutorials: 'Tutorials',
  Tenant: 'Tenant',
  MFA_Management: 'MFA Management',
  Videos: 'Videos',
  User_Guide: 'User Guide',
  Upload_Video: 'Upload Video',
  Upload_File: 'Upload File',
  Select_Categories: 'Select Categories',
  Select_Access_By: 'Select Access by',
  Assign_User: 'Assign user',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  Validity_period: 'Validity period',
  Project_Name: 'Project Name',
  Engagement_Name: 'Engagement Name',
  Engagement_Model: 'Engagement Model',
  Customer: 'Customer',
  OTP: 'OTP',
  Overdue_by: 'Overdue by',
  Type: 'Type',
  Search: 'Search',
  Rows_Per_Page: 'Rows per page',
  To_Duplicate: '',
  No_Client_Found: 'No client found',
  Scope_Id: 'Scope',
  Consultant_Fullname: 'Consultant ',
  Delivery_Manager_Fullname: 'Delivery Manager',
  Delivery_Manager: 'Delivery Manager',
  Client_Fullname: 'Client ',
  Forecasted_Date: 'New expected date',
  Delivery_Date: 'Delivery date',
  Complexity_Name: 'Complexity',
  Pending: 'Pending',
  Drafted: 'Drafted',
  Archived: 'Deleted',
  Archive: 'Archive',
  Production: 'Production',
  Management_Catalog: 'Catalog',
  Management_Material: 'Time & Material',
  Material_Drafts: 'Drafts',
  Material_Production: 'Production',
  Material_Closed: 'Closed',
  Material_Deleted: 'Deleted',
  Closed: 'Closed',
  Validated: 'Validated',
  Actions: 'Actions',
  Video: 'Video',
  Title: 'Title',
  Access_By: 'Access by',
  File: 'File',
  Comments: 'Comments',
  Amount: 'Price',
  Cancellation_Reason: 'Cancellation reason',
  Modification_Reason: 'Modification reason',
  Workunit_Name: 'Deliverable',
  Workunit_Reference: 'Reference',
  Assess_And_Sign: 'Assess and sign',
  Approve_And_Sign: 'Approve and sign',
  Validated_Bm: 'Validated by delivery manager',
  Client_Acceptance_At_Completion: 'Accepted by client at completion',
  Estimated_At_Completion: 'Submitted by consultant',
  Representative: 'Representative',
  Nothing: 'No results found',
  Deliverables_Evaluation: 'Deliverables evaluation',
  Accept: 'Accept',
  Deliverables_Acceptance: 'Deliverables acceptance',
  Validate_Selected_Deliverables: 'Validate selected deliverables',
  Deliverables_Validation: 'Deliverables validation',
  Deliverable_Submission: 'Deliverables submission',
  Cancel_Submission: 'Cancel submission',
  Submit_Selected_Deliverables: 'Submit selected deliverables',
  Cancel_Selected_Deliverables: 'Cancel selected deliverables',
  Cancel_Submission_Selected_Deliverables: 'Cancel submission of selected deliverable(s)',
  Cancel_Validation_Selected_Deliverables: 'Cancel validation of selected deliverable(s)',
  WU_Parameters: 'Workunit parameters',
  Quick_action: 'Quick actions',
  Quick_view: 'Quick View',
  Items_Selected: ' items selected',
  Add_Client: 'Add client',
  Add_Catalog: 'New catalog',
  Deliverable_Projection: 'Deliverable projection',
  // Date_should_be_superior_to: 'Date should be superior to',
  //Date_should_be_inferior_to: 'Date should be inferior to',
  Month_Should_Be_Inferior_To: 'The end month must be later than',
  Date_Should_Be_Superior_To: 'The date must be later than',
  Date_Should_Be_Inferior_To: 'The date must be earlier than',
  Date_Invalid: 'Date invalid',
  Edit_Order: 'Edit order',
  Start_Frequency_Date: 'Starting frequency date',
  End_Frequency_Date: 'Ending frequency date',
  No_Scope: 'No scope',
  Deliverable_Name: 'Deliverable name',
  Contract_Reference: 'Reference',
  Order_Price: 'Order price',
  Apply_Discount: 'Apply discount',
  Final_Price: 'Final price',
  Quote_Reference: 'Quote reference',
  Confirm_Delete_Deliverables: 'Are you sure you want to delete this deliverable ?',
  Text_Not_Affilied_1: 'You can try disconnecting and reconnecting.',
  Text_Not_Affilied_2: 'Please contact an administrator if the issue persist.',
  Initial_Deliverable_Date: 'Initial Delivery Date',
  Reason: 'Comment your change',
  Enter_Text_Here: 'Enter text here',
  New_Expected_Date: 'New expected date',
  Modify_Deliverable: 'Modify deliverable ',
  Client_Not_Indicated: 'Client not indicated',
  Error_Input_Date_Max_Date_Inferior_Start_Date: 'End date should be equal or superior to start date',
  Trigger_Validation_Summary: 'This action will trigger the download of an Excel file.',
  Quote_Summary: 'Quote summary',
  Select_Catalog: 'Select a catalog',
  Affair_Date: 'Engagement date',
  Engagement_Date: 'Engagement date',
  Project_Ref: 'Project name and Ref',
  Otp_Ref: 'OTP name and Ref',
  Text2_Chrono_Drawer: 'Please complete it below before going ahead',
  Text1_Chrono_Drawer: 'There is no reference chrono for this order. ',
  Text2_Affair_Drawer: 'Please select one engagement below before going ahead',
  Text2_Client_Drawer: 'Please select one client below before going ahead',
  Text1_Affair_Drawer: 'There is no engagement for this order',
  Text1_Client_Drawer: 'There is no client for this order',
  Complete_Affair: 'Complete order',
  Quarter_Displayed: 'View by quarters',
  Forecasted_Date: 'Forecasted date',
  Reforecasted_Date: 'Reforecasted date',
  Forecasted_Delivery: 'Forecasted delivery',
  Select_Forecasted_Date: 'Select forecasted date',
  Affair_Not_Indicated: 'Engagement not indicated',
  Draft_Reference: 'Chrono reference',
  Draft_Reference_Text: 'Reference (chrono)',
  Go_Ahead: 'Proceed',
  Create_Work_Unit_To_Proceed: 'Create a work unit to proceed.',
  Contect_Admin_Config_Tenant_Workmonth: 'Missing data. Contact space administrator',
  To_Deliver: 'To deliver',
  Acceptation_With_Reserve: 'Acceptation with reserve',
  Validated_With_Reserve: 'Validation with reserve',
  Delivery_Manager: 'Delivery manager',
  Validate_Order: 'Validate quote',
  Current_Order_Datagrid_No_Row_Overlay: 'Select work units in catalog, delivery month above and add it on your order.',
  All_Project: 'All scopes',
  Save_For_Later: 'Save for later',
  Order_Summary: 'Summary',
  My_Order: 'My order',
  Enter_Professional_Info_Tm: 'Professional Info',
  Engagement_By_Name_Tm: 'Engagement by Name',
  Engagement_By_Name_Text_Tm: 'Select a name',
  Engagement_By_Otp_Code_Tm: 'Engagement by OTP code',
  Engagement_By_Otp_Code_Text_Tm: 'Select an OTP Code',
  Reference_Chrono_Tm: 'Reference (chrono)',
  Reference_Chrono_Text_Tm: 'Enter chrono',
  Representative_Select_Tm: 'Representative (s)',
  Representative_Select_Text_Tm: 'Select a representative',
  Project_Name_Tm: 'Project Name',
  Project_Name_Text_Tm: 'Enter project name',
  Spec_Reference_Tm: 'Spec Reference',
  Spec_Reference_Text_Tm: 'Enter spec reference',
  Start_Date_Tm: 'Start Date',
  Date_Text_Tm: 'Enter date',
  End_Date_Tm: 'End Date',
  Purchase_Order: 'Purchase Order',
  Purchase_Order_Text_Tm: 'Enter purchase order',
  Scopes_Tm: 'Scope(s)',
  Scopes_Text_Tm: 'Select scope on the list or create your own',
  Stake_Holders_Tm: 'Stakeholders',
  Delivery_Managers_Tm: 'Delivery Manager(s)',
  Head_Text_Tm: 'Enter a name or select on the list',
  Consultants_Tm: 'Consultant(s)',
  Client_Name_Tm: 'Client Name',
  Client_Connection_To_Platform_Tm: "Client's connection to the platform",
  Enter_Affair_Parameters: 'Enter engagement parameters',
  Create_New_Order: 'Create new order',
  Create_Time_Material_Order_Tm: 'Create Time & Materials Order',
  Save_As_Draft_Tm: 'Save as Draft',
  Validate_Tm: 'Validate',
  Cancel_Tm: 'Cancel',
  Affair_Parameters: 'Engagement parameters',
  Edit_Deliverables: 'Edit deliverables',
  Some_Deliverable_Cannot_Be_Edited: 'Some deliverable are not editable',
  Reload_User_On_Tenant_Permissions: 'Reload user on tenant permissions',
  Reload_User_Permissions: 'Reload user permissions',
  Users_Roles: 'Users roles',
  Customer_Administration: 'Customer Administration',
  Permissions: 'Permissions',
  Search_By_Role: 'Search by role',
  Reset_Filters: 'Reset filters',
  Delete_deliverables: 'Delete deliverable(s)',
  These_Deliverables_Are_Not_Deletable: 'Unable to delete selected deliverable(s)',
  Some_Of_These_Deliverables_Are_Not_Deletable: 'Some deliverable(s) cannot be deleted',
  Name_Deliverable: 'Deliverable name',
  Deliverable_Reference: 'Deliverable reference',
  Deliverable_Description: 'Deliverable description',
  Deliverable_Content: 'Deliverable content',
  Users_Gestions: 'Users gestion',
  Content_New_Deliverable: 'Content new deliverable',
  Roles: 'Roles',
  Drag_And_Drop_Text_Catalog: 'Drag and drop .xlxs catalog here',
  Download_Template: 'Download template',
  Customer_Validation: 'Customer validation',
  Select_Delivery_Date: 'Select delivery date',
  Delivery_Date: 'Delivery date',
  Not_Attribued: 'Not attribued',
  Consultant_Submission: 'Consultant submission',
  Clear_Filters: 'Clear filters',
  Excellent: 'Excellent',
  Above_Expectations: 'Above expectations',
  Average: 'Average',
  Below_Expectations: 'Below expectations',
  Not_Acceptable: 'Not Acceptable',
  Partial_Duplicate: 'Only custom deliverables can be duplicated',
  Save_Change: 'Save',
  Not_Submited: 'Not submited',
  Refused_DC: 'Refused by DM',
  Reserve_DC: 'Reserve by DM',
  Refused_Customer: 'Refused by customer',
  Reserve_Customer: 'Reserve by customer',
  Validated_DC: 'Validated by DM',
  Validated_Customer: 'Validated by customer',
  Diffuse_External: 'External broadcasting',
  Is_Private: 'Is private',
  Charge: 'Workload',
  Welcome_Back: 'Welcome back',
  Mark_All_As_Read: 'Mark all as read',
  Client_Acceptance: 'Client acceptance',
  Send_Rating: 'Send rating',
  See_All_Notifications: 'See all notifications',
  See_Less_Notifications: 'See less notifications',
  More_Filters: 'More filters',
  Re_Submit: 'Submit again',
  Validate_And_Assess: 'Validate and assess',
  Validate_With_Reserve: 'Validate with reserve',
  To_Be_Submitted: 'To be submitted',
  To_Be_Validated: 'To be validated',
  To_Be_Confirmed: 'To be accepted',
  To_Be_Assessed: 'To be assessed',
  Mission_Refusal_Message: 'A deliverable has been refused',
  Mission_Accept_Partial_Message: 'A deliverable has been accepted with reserve',
  Mission_Just_Shipped_Message: 'A deliverable has been send',
  Mission_Just_Confirmed: 'A deliverable has been confirmed',
  Scope_New_Assignation_Message: 'You have been assigned to an new scope on an order',
  Mission_New_Client_Assignation_Message: 'You have been assigned to review some deliverable on an order',
  Mission_New_Consultant_Assignation_Message: 'You have been assigned to some deliverables on an order',
  Mission_Overdue_Message: 'Some deliverables are overdue',
  Mission_Bad_Ranking_Message: 'A deliverable has been badly ranked',
  Submit_Again: 'Re-submit',
  New_User: 'New user',
  Save_User: 'Save user',
  Last_Name: 'Last Name',
  First_Name: 'First Name',
  Position: 'Position',
  Mail: 'Mail',
  Department: 'Department',
  Direction: 'Direction',
  Tenants: 'Tenants',
  Update_Client: 'Update client',
  Updating: 'Updating...',
  Creating: 'Creating...',
  Bm: 'Business Manager',
  Consultant: 'Consultant',
  Customer: 'Customer',
  // Head: 'Delivery Coordinator',
  Head: 'Delivery Coordinator',
  Admin: 'Administrator',
  Support_Bu: 'Support BU',
  Delivery_Manager: 'Delivery Manager',
  // Delivery_Coordinator: 'Delivery Coordinator',
  Delivery_Coordinator: 'Delivery Coordinator',
  Bu: 'Bu',
  Bu_Support: 'BU Support',
  Open_Access: 'Open access',
  '2_Characters_Minimum': '2 characters min',
  Name_Catalog: 'Catalog name',
  Create_An_Order: 'Select',
  Order_Parameter: 'Order parameters',
  Save_Modifications: 'Save modifications',
  Submit_Refusal: 'Submit refusal',
  Submit_Accepted: 'Submit acceptation',
  Accept_With_Reserve: 'Accept with reservation',
  Leave_A_Comment: 'Leave a comment',
  Select_A_Consultant: 'Select a consultant',
  Select_A_Scope: 'Select a scope',
  Select_A_Customer: 'Select a customer',
  Validity_To: 'Validity to',
  Validity_From: 'Validity from',
  Internal_Contact: 'Internal contact',
  Create_Workunit: 'Create Workunit',
  Client_Catalog: 'Client',
  Validity_Period: 'Validity period',
  Last_Updated: 'Last Updated',
  Create_Catalog: 'Create catalog',
  Update_Catalog: 'Update catalog',
  Create_Categories: 'Create categories',
  Catalog_Workunits: 'Catalog Workunits',
  Scope_Name: 'Scope',
  Create_Client: 'Create client',
  Ref_Order: 'Reference order',
  Reference_Spec: 'Reference',
  Mission_Period: 'Order period',
  Add_A_New_Order: 'Add a new quote',
  Go_To_Selection_Workunits: 'Selection',
  Go_To_Summary: 'Summary',
  Go_To_Parameters_Workunits: 'Parameters',
  Go_To_Parameters_Affectations_Workunits: 'Assignment',
  Remove_This_Element: 'Remove this workunit',
  Cant_Remove_Because_Used: "Can't remove because it's used",
  Is_Minimun_Because_Assignations: 'is the minimun because it is assigned',
  Ref_Order_Items: 'Purchase order reference',
  Ref_Workspace: 'Reference work space',
  Total_Charge: 'Total workload',
  Otp_Code: 'Code OTP',
  Choose_By_OTP_Code: 'Choose engagement by otp',
  Choose_By_Name: 'Choose engagement by name',
  Affair_Name: 'Engagement name',
  Total_Price: 'Total price',
  Not_Defined: 'Not defined',
  Validated_By: 'Default Delivery manager',
  Po_Ref: 'PO Ref',
  Number_Of_Workunits: 'N° workunits',
  Name_Spec: 'Project Name',
  Ref_Spec: 'Spec Reference',
  To_Duplicate: '',
  Edit_Order_Workunit: 'Assign selected items',
  Start_Date: 'Start date',
  End_Date: 'End date',
  Add_Selected: 'Add selection',
  Edit_Workunit: 'Edit workunit ',
  Price: 'Price',
  Load_Estimation: 'Load estimation',
  Select_validity_dates: 'Select validity dates',
  Add_Comment: 'Add a comment',
  Accept_Standard: 'Acceptance standard',
  Level_Standard: 'Level standard',
  Deliverables: 'Deliverables',
  Add_Workunit_Livrable: 'Add a deliverable',
  Create_Workunit: 'Creation workunit',
  Reference_Of_Workunit: 'Reference of the workunit',
  Name_Of_New_Workunit: 'Name of the workunit',
  Description_New_Workunit: 'Description of the workunit',
  Input_New_Workunit: 'Acceptable standard description',
  Output_New_Workunit: 'Acceptable output description',
  Level_Standarad_Workunit: 'Level standard description',
  Accept_Standard_Workunit: 'Acceptable standard description',
  Outputs: 'Outputs',
  Inputs: 'Inputs',
  Submitted: 'Submitted',
  Client_Accepted: 'Accepted by client',
  Refused: 'Refused',
  Client_Refused: 'Refused by client',
  Reset_Filter: 'Reset_filter',
  Description_New_Deliverable: 'Describe your deliverable',
  Validate_The_Modifications: 'Validate modifications',
  Disconnect: 'Disconnect',
  Active_User_Avatar: 'Your avatar',
  Close: 'Close',
  Back_Up: 'Back up',
  Saving_Location: 'Saving location',
  Estimate_Charge: 'Estimate workload',
  Optional: 'Optional',
  Order_Number: 'Order No',
  Add_A_Number: 'Add a number',
  Date_Delivery: 'Expected delivery date',
  Add_This_New_Deliverable: 'Add this new deliverable',
  Select_The_Start_Date: 'Select the start date',
  Edit_Deliverable: 'Edit the deliverable',
  Generate_Sheet: 'Export',
  Duplicate_Deliverable: 'Duplicate a deliverable',
  Done: 'Completed',
  Open: 'Open',
  One_Time: 'One time only',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Other: 'Other',
  Status: 'Status',
  Name: 'Name',
  Reference: 'Reference',
  Edit: 'Edit',
  Deliverables: 'Deliverables',
  Deliverable_Date: 'Delivery date',
  Frequency: 'Frequency',
  Submitted: 'Submitted',
  Validated: 'Validation',
  Accepted: 'Accepted',
  Rating: 'Note',
  Comment: 'Comment',
  Action: 'Actions',
  Add_New_Deliverable: 'Add new deliverable',
  Reference_Of_New_Deliverable: 'Reference of the deliverable',
  Name_Of_New_Deliverable: 'Name of the deliverable',
  Added: 'Added',
  Custom: 'Custom',
  Updated: 'Updated',
  Cancelled: 'Cancelled',
  Tags: 'Tags',
  Reference: 'Reference',
  Name: 'Name',
  Workunit_Desc: 'Description',
  Description: 'Description',
  Content: 'Content',
  Content2: 'Content 2',
  Content3: 'Content 3',
  Content4: 'Content 4',
  Content5: 'Content 5',
  Workload: 'Workload',
  Price: 'Price',
  Total: 'Total',
  Complexity: 'Complexity',
  Forecasted_Date: 'New expected date',
  Scope: 'Scope',
  Client: 'Client',
  Type: 'Type',
  OTP: 'OTP',
  Overdue_By: 'Overdue by',
  Edit_Client: 'Edit client',
  Submitted: 'Consultant submission',
  Validated: 'DM assignment',
  Dm_Validation: 'DM validation',
  // Accepted: 'Client acceptation',
  Rating: 'Note',
  Submit: 'Submit',
  Modify: 'Modify',
  Duplicate: 'Duplicate',
  Duplicate_Quote: 'Duplicate quote',
  Duplicate_Quote_Confirmation_Text:
    'Do you want to duplicate this quote ? When duplicated, the copy goes back to quotes',
  Duplicate_TM_Order_Confirmation_Text:
    'Do you want to duplicate this T&M Order ? When duplicated, the copy goes back to drafts',
  Dont_Copy: "Don't copy",
  Restore: 'Restore',
  Restore_Account: 'Restore Account',
  Restore_Success: 'The User account has been restored successfully!',
  Cancel_Validation: 'Cancel validation',
  Cancel_Submission: 'Cancel submission',
  Cancel: 'Cancel',
  OK: 'OK',
  Close_Order: 'Close order',
  Close_Order_Confirmation_Text:
    'You are about to close the order {{orderId}}, all deliverables not revised by your client will be cancelled. Would you like to proceed ?',
  Order_Closed_Message: 'This order with order ID {{orderId}} is closed',
  Reopen_From_Order_Close_Page: 'You can always reopen it from the order close page',
  Error_Occurred: 'An error occurred !',
  Please_Provide_Reason_Cancellation: 'Please provide a reason for cancellation:',
  Enter_Reason_Here: 'Enter reason here...',
  Understood: 'Understood',
  Reason_For_Cancellation: 'Reason for Cancellation',
  Reason_Is_Mandatory: 'Reason is mandatory.',
  To_Be_Sent: 'To be sent',
  Waiting_For_Signature: 'Waiting for signature',
  To_Be_Signed: 'To be signed',
  Error_Reported: 'Error reported',
  Finished: 'Finished',
  Delete: 'Delete',
  Cancel_Assessment: 'Cancel assessment',
  External_Broadcasted: 'External broadcasted',
  Cancel_Refusal: 'Cancel refusal',
  Cancel_Comment: 'Cancel comment',
  Cancel_Acceptance: 'Cancel acceptance',
  Not_Disclosed: 'Not disclosed',
  Select_Wu_Catalog: 'Select WU in catalog for each delivery month and add to your quote',
  No_Archived_Catalogs: 'No archived catalogs',
  No_Archived_Clients: 'No archived clients',
  Document_Title: 'Document title',
  Search_By_Name_Or_Ref: 'Search by project name or reference',
  Create_New_Quote: 'Create new quote',
  Add_Deliverable: 'Add deliverable',
  Reset_All: 'Reset all',
  Archives: 'Deleted',
  Used_Complexity: 'This complexity is used in a workunit',
  Details: 'Details',
  No_Alerts: 'You currently do not have any alerts',
  See_Details: 'See details',
  Hide_Details: 'Hide details',
  Extract_In_Pdf: 'Extract in PDF',
  Extract_In_Excel: 'Extract in Excel',
  EDelivery: 'E-Delivery',
  Reset_Password: 'Resend temporary password',
  Confirm_Client_Reset_Password: 'Are you sure you want to resend the temporary password of this client?',
  Confirm_Reset_Password: 'Yes, resend',
  Remember_Check_Spams: 'Remember to check spams',
  Client_Parameters: 'Client parameters',
  Yes: 'Yes',
  No: 'No',
  Client_Connection_Platform: "Client's connection to the platform",
  Accept_Dm: 'Deliverable accepted by Internal M|P user in place of the client',
  Reserve_Dm: 'Deliverable accepted with reserve by Internal M|P user in place of the client',
  Refuse_Dm: 'Deliverable refused by Internal M|P user in place of the client',
  Assessed_Dm: 'Deliverable assessed by Internal M|P user in place of the client',
  Financial: 'Financial',
  Technical: 'Technical',
  Document_Location: 'Document location',
  Signed_By_Dm: 'Process realized by M|P internal user',
  Deactivate_Schedule_Anonymize: 'Deactivate Account & Schedule Anonymization',
  Deactivate_Anonymize: 'Deactivate Account & Anonymize GDPR Data Now',
  Deactivate: 'Deactivate',
  Deactivate_User: 'Deactivate User',
  Unassign_User: 'Unassign User',
  Confirm: 'Confirm',
  Confirm_Data_Anonymization: 'Confirm data anonymization',
  Confirm_Schedule_Anonymization: 'Confirm scheduled data anonymization',
  Schedule_Anonymize_Confirm_Text:
    'Deactivates the account immediately and schedules anonymization of personal data after the applicable retention period',
  Unassign_User_Button: 'Yes, Unassign User',
  Confirm_Unassign_User: 'Are you sure you want to unassign the user from this client?',
  Schedule_Anonymize_Tooltip:
    'Deactivates the account immediately and schedules anonymization of personal data after the applicable retention period',
  Anonymize_Tooltip: 'Deactivate the user account and immediately anonymize all personal data',
  Confirm_Anonymize_Data_Now:
    'Deactivates the account immediately and anonymizes GDPR data now. Do you want to continue?',
  Confirm_Delete_Videos: 'Are you sure you want to delete this video ?',
  Confirm_Guide_Videos: 'Are you sure you want to delete this guide ?',
  Open_Access_Confirm:
    'You are about to open access to the client. He will receive an email with a temporary password.',
  Continue: 'Continue',
  Open_Access_Temp_Pass: 'Temporary Password for Client',
  Note: 'Note:',
  Confirmation: 'Confirmation',
  Change_Baseline_Confirmation_Text: 'Are you sure you want to change the baseline of this order?',
  Baseline_Change_Note:
    'Before continuing,  ensure that you removed all unnecessary items and cancelled submission of the deliverables that you will need to update or delete',
  Baseline_Cancel_Note:
    'The changes you have made will be forgotten, and the original order will return to production.',
  Baseline_Pagename: 'New Baseline Workunits',
  Save_Next: 'Save & Next',
  Next_Tm: 'Next',
  Engagement_Parameters: 'Engagement Parameters',
  Affectation: 'Assignment',
  Order_Summary: 'Order Summary',
  Engagement_Subtitle: 'Update engagement parameters',
  New_Baseline_Subtitle: 'Create & update workunits',
  Affectation_Subtitle: 'Assign consultants',
  Order_Summary_Subtitle: 'Assign DM & Preview',
  Edit_Baseline: 'Edit Baseline',
  Base_Line_Done: 'Done',
  Ai_Agent: 'AI Agent',
  Switch_Language: 'Switch language',
  Help: 'Help',
  Total_Workunits: 'Total Workunits',
  Cancel_Delete: 'Cancel delete',
  Newwu: 'New WU',
  Cancel_Newwu: 'Cancel New WU',
  Version_History: 'Version History',
  Kpi_Metrics: 'KPI Metrics',
  To_Do: 'To-do',
  Dashboard: 'Dashboard',
  Workflow: 'Workflow',
  Acceptance: 'Acceptance',
  Performance: 'Performance',
  Cover_Ratio: 'Cover Ratio',
  Financial_Kpi: 'Financial KPI',
  Financial_Table: 'Financial Table',
  Purchase_Order: 'Purchase Order',
  Metrics: 'Metrics',
  Affair_Otp: 'Affair OTP',
  Pendingat: 'Pending at',
  Kpi_Rating: 'Rating',
  Kpi_Status: 'Order Status',
  Kpi_Delivery_Status: 'Deliverable Status',
  Export_Table_Data: 'Export table data',
  Skip_Assessment: 'Skip Assessment',
  Refuse: 'Refuse',
  Todo_Create_Order: 'What type of order would you like to create?',
  Quote: 'Quote',
  Define_Parameters: 'Define parameters',
  Workunits: 'Workunits',
  Select_Workunits: 'Select workunits',
  Switch_Client: 'Switch Client',
  Search_Client: 'Search Client...',
  MFA_Title: 'Two-Factor Authentication (MFA)',
  MFA_Status_Title: 'Status:',
  MFA_Enabled: 'Enabled',
  MFA_Disabled: 'Disabled',
  MFA_Description:
    'Two-factor authentication adds an extra layer of security to your account. When enabled, you will need to provide a second factor — either from your authenticator app or via email — in addition to your password when logging in.',
  MFA_Important: 'Important:',
  MFA_Notice_Intro: 'MFA is enabled.',
  MFA_Notice_Admin: 'Only an administrator can disable MFA for your account.',
  MFA_Important_Message:
    'If you lose access to your second factor, contact your administrator to disable MFA for your account.',
  MFA_Setup_Required: 'MFA Setup Required:',
  MFA_Setup_Required_Message:
    'Your administrator has enabled multi-factor authentication for your account. You must complete the setup to continue using the application.',
  MFA_Disable_Confirm_Title: 'Disable Two-Factor Authentication?',
  MFA_Disable_Confirm_Text: 'Are you sure you want to disable MFA? This will make your account less secure.',
  Cancel_Label: 'Cancel',
  Admin_MFA_Title: 'Multi-Factor Authentication Management',
  Client_Type: 'Client Type',
  Search_Users: 'Search users...',
  Enable_MFA: 'Enable MFA',
  Disable_MFA: 'Disable MFA',
  Clear_Selection: 'Clear Selection',
  Table_Name: 'Name',
  Table_Email: 'Email',
  Table_Client_Type: 'Client Type',
  Table_MFA_Status: 'MFA Status',
  Table_Method: 'Method',
  Table_Setup_Completed: 'Setup Completed',
  Table_Actions: 'Actions',
  No_Users_Found: 'No users found',
  No_Contacts_Found: 'No contacts found',
  Users_Selected: '{{count}} user(s) selected',
  Internal_User: 'Internal',
  External_User: 'External',
  Yes_Label: 'Yes',
  No_Label: 'No',
  MFA_Method_Label: 'MFA Method:',
  Authenticator_App_Label: 'Authenticator App (TOTP)',
  Authenticator_App_Subtext: 'User will be prompted to scan a QR code on next login.',
  Email_OTP_Label: 'Email OTP',
  Email_OTP_Subtext: "Immediately active — a code is sent to the user's email each login. No setup required.",
  Enable_MFA_User_Title: 'Enable MFA for User?',
  Disable_MFA_User_Title: 'Disable MFA for User?',
  Enable_MFA_User_Text: 'Are you sure you want to enable MFA for',
  Disable_MFA_User_Text: 'Are you sure you want to disable MFA for',
  Enable_MFA_Multiple_Title: 'Enable MFA for Multiple Users?',
  Disable_MFA_Multiple_Title: 'Disable MFA for Multiple Users?',
  Enable_MFA_Multiple_Text: 'Are you sure you want to enable MFA for',
  Disable_MFA_Multiple_Text: 'Are you sure you want to disable MFA for',
  Backlog: 'Backlog',
  Production_Title: 'Production',
  Control_Title: 'Control',
  To_Deliver_Label: 'To deliver',
  Submitted_Label: 'Submitted',
  Reforcast_Label: 'Reforcast',
  Canceled_Label: 'Canceled',
  Validated_Label: 'Validated',
  Validated_With_Reservations: 'Validated with reservations',
  Refused_Label: 'Refused',
  Waiting_For_Validation: 'Waiting for validation',
  Accepted_Label: 'Accepted',
  Accepted_With_Reservation: 'Accepted with reservation',
  Client_Title: 'Client',
  Delivery_manager: 'Delivery Manager',
  Waiting_For_Acceptance: 'Waiting for acceptance',
  Waiting_For_Assessment: 'Waiting for assessment',
  Quality_Title: 'Quality',
  Average_Note: 'Average note',
  Rated_2: 'Rated 2',
  Rated_1: 'Rated 1',
  Search_Consultant: 'Search consultant',
  // Hardcoded UI Strings - Functional Labels
  Mission_Total: 'Mission Total',
  Mission_In_eDelivery: 'Mission In e-Delivery',
  Mission_Not_In_eDelivery: 'Mission Not In e-Delivery',
  Cover_Ratio: 'Cover Ratio',
  Country: 'Country',
  Customers: 'Customers',
  Client: 'Client',
  OTP: 'OTP',
  DM: 'DM',
  Consultant: 'Consultant',
  Deliverable_Status: 'Deliverable status',
  Order_ID: 'Order ID',
  Order_Type: 'Order type',
  BM: 'BM',
  PO: 'PO',
  Customer_Site: 'Customer Site',
  Star_Rating: 'Star rating',
  Delivery_Manager: 'Delivery manager',
  Business_Manager: 'Business manager',
  Chef_De_Mission: 'Chef de mission',
  Administrateur: 'Administrateur',
  Support_BU: 'Support BU',
  DDCC: 'DDCC',
  Directeur_BU: 'Director BU',
  BU_Support: 'BU Support',
  Deactivated: 'Deactivated',
  Role: 'Role',
  Categories: 'Categories',
  Select_Consultant: 'Select Consultant',
  Select_Delivery_Managers: 'Select Delivery Managers',
  Select_Representative: 'Select Representative',
  Engagement: 'Engagement',
  Dates: 'Dates',
  ID: 'ID',
  Select_Engagement: 'Select engagement',
  Otp_Name: 'Name OTP',
  Select_Scope: 'Select scope',
  Select_Client: 'Select client',
  Select_Business_Manager: 'Select business manager',
  Select_Delivery_Manager: 'Select delivery manager',
  Select_Order_Id: 'Select Order ID',
  Select_OrderWorkUnits_ID: 'Select OrderWorkUnits ID',
  Filter_Categories: 'Filter Categories',
  Start_Date: 'Start Date',
  End_Date: 'End Date',
  Start_Month: 'Start Month',
  End_Month: 'End Month',
  Currency: 'Currency',
  Scope: 'Scope',
  Copy: 'Copy',
  Download: 'Download',
  Details: 'Details',
  Metrics: 'Metrics',
  Feedback: 'Feedback',
  // Date/Format Strings
  Date: 'Date',
  Date_From: 'Date from',
  Date_To: 'Date to',
  Search: 'Search',
  // User Guidance & Help Text
  Ask_Me_Something: 'Ask me something...',
  Share_Comments_Placeholder: 'Please share your comments...',
  Search_Placeholder: 'Search...',
  Search_Status_Placeholder: 'Search status...',
  Select_Option: 'Select...',
  Select_All: 'Select All',
  Select_Status_Placeholder: 'Select Status...',
  Select_Tenants: 'Select tenants',
  Filter_By_Scopes: 'Filter by scope(s)',
  View_More_Categories: 'View More Categories',
  View_More_Users: 'View More Users',
  Create_Own_Scope: 'Create your own scope',
  No_Workunits_Catalog: 'No Workunits in this catalog',
  // Notification/Settings
  Deactivate_Notifications: 'De-activate notifications',
  Minimal_Notifications: 'Minimal notifications',
  Realtime_Notifications_Default: 'Real-time notifications (Default)',
  Affect_Every_Page: 'Affect every page',
  // Account Management
  Deactivate_Anonymize_Now: 'Deactivate Account & Anonymize GDPR Data Now',
  Deactivate_Schedule_Anonymization: 'Deactivate Account & Schedule Anonymization',
  Accept_Terms_Checkbox: 'I accept the general conditions of use and certify that I have read the entire document',
  // Button/Interaction Labels
  Copy_Response: 'Copy response',
  Like_Response: 'Like response',
  Dislike_Response: 'Dislike response',
  Expand_Row: 'Expand row',
  More_Actions: 'More',
  Placeholder_Text: 'Placeholder',
  Range_Option: 'Range',
  Single_Option: 'Single',
  Rated_Zero: 'Rated 0',
  All_Option: 'ALL',
  // Tooltip/Descriptive Text
  Tooltip_Scope_Rows: 'All rows without a scope will not appear on the next view',
  Tooltip_PO_Amount: 'Amount of the Purchase Order coming from the client',
  Tooltip_Cancel_Incorporation: 'Cancel the incorporation of an Added WU to the baseline.',
  Tooltip_Cancel_Deletion: 'Cancels a deletion request and restores the workunit to the status it had before deletion.',
  Tooltip_Incorporate_WU: 'Incorporate an Added WU to the baseline.',
  Tooltip_Reintegrate_WU: 'Reintegrates a previously cancelled workunit into the new baseline.',
  Tooltip_Remove_WU: 'Removes a workunit (WU) from the new baseline.',
  Tooltip_Tab_Switch: 'Tab switch between technical and financial',
  Error_End_Date_Expired: 'The end date is already expired',
  PO_Reference: 'Purchase order reference',
  // Additional Hardcoded Strings
  No_Data_Found: 'No data found',
  Email_Notifications: 'Email notifications',
  Mode: 'Mode:',
  View: 'View:',
  By_Month: 'By Month',
  By_Date: 'By Date',
  Deliverables_Assessment: 'Deliverables assessment',
  Share_Your_Ratings: 'Share your valuable ratings & feedback below',
  Skip_Note: 'Note: Clicking "skip" will accept the deliverable',
  Without_Rating_Status: 'Without a rating. Status will be "Not Assessed"',
  Skip: 'Skip',
  Dashboard_Notifications_Title: 'Dashboard notifications',
  Critical_Account_Notifications: 'We may send critical account notifications beyond your notification settings.',
  Receive_Every_Update: 'Receive every update the moment it happens so you never miss a thing.',
  Key_Updates_Only: 'Get only the key updates that matter to keep you on track.',
  Stay_Distraction_Free: 'Stay distraction-free with no alerts or reminders.',
  Loading_Chart: 'Loading chart...',
  Report_Generated_Successfully: 'The requested report has been generated successfully.',
  Copy_Response: 'Copy response',
  Like_Response: 'Like response',
  Dislike_Response: 'Dislike response',
  Vertical_Tabs_Example: 'Vertical tabs example',
  Disabled_Tabs_Example: 'Disabled tabs example',
  Quick_Access_Tabs: 'Quick access tabs',
  Collapsible_Table: 'Collapsible table',
  Basic_Tabs_Example: 'Basic tabs example',
  Settings: 'Settings',
  Create_Client: 'Create client',
  Directeur_BU: 'Directeur BU',
  BU_Support: 'BU Support',
  Back: 'Back',
  Hide_All: 'Hide all',
  Show_All: 'Show all',
  Consultant_Submission: 'Consultant Submission',
  Dm_Validation: 'DM Validation',
  Client_Acceptance: 'Client Acceptance',
  Pending_At: 'Pending at',
  Submitted: 'Submitted',
  Not_Submitted: 'Not Submitted',
  To_Be_Validated: 'To Be Validated',
  Validation_Complete: 'Validation Complete',
  Pending_Submission: 'Pending Submission',
  To_Be_Accepted: 'To Be Accepted',
  Acceptance_Complete: 'Acceptance Complete',
  Pending_Delivery: 'Pending Delivery',
  Complete: 'Complete',
  Pending_Client: 'Pending Client',
  Pending_DM: 'Pending DM',
  Pending_Consultant: 'Pending Consultant',
  BU: 'BU',
  Deliverable: 'Deliverable',
  Reference: 'Reference',
  Create_Report: 'Create report',
  Create_Technical_Report: 'Create technical report',
  Create_Financial_Report: 'Create financial report',
  Enter_Title_Technical_Report: 'Enter a title for your technical monitoring report',
  Enter_Title_Financial_Report: 'Enter a title for your financial monitoring report',
  Your_Title: 'Your title',
  Select_Scopes_For_Report: 'Select scope(s) you want in your report',
  Select_Production_For_Report: 'Select production you want in your report',
  No_Date_Found_For_Scope: 'No date found for this scope',
  Or: 'Or',
  Select_Deliverables_By_Hand: 'select deliverables by hand',
  Deliverable_Selected: 'Deliverable selected',
  Deliverables_Selected: 'deliverables selected',
  Select_At_Least_One_Scope_And_Date:
    'Select at least one scope and one date or select deliverables by hand to display clients',
  Select_Clients_Only_Assigned: 'Select clients who will only receive deliverables assigned to them',
  Select_Client_All_Deliverables: 'Or select client who will receive all deliverables of the production',
  Are_You_Sure_Create_Report: 'Are you sure you want to create a report ?',
  Will_Lose_Progress: 'You will loose all your progress',
  Confirm_Report_Creation: 'Confirm report creation',
  Cancel_Report_Creation: 'Cancel report creation',
  Missing_Required_Fields: 'Missing required fields',
  All_Production: 'All production',
  Send_To_Client: 'Send to client',
  Mark_As_Signed: 'Mark as signed',
  Download_Document: 'Download document',
  Delete_Report: 'Delete report',
  Cancel_The_Sending: 'Cancel the sending',
  Preview: 'Preview',
  Filters: 'Filters',
  // KPI Metrics dropdown - section headers (EDD-424)
  Delivery: 'Delivery',
  'Coverage & Data Completeness': 'Coverage & Data Completeness',
  // Financial Table status matrix - row labels (EDD-424)
  Purchased: 'Purchased',
  Baseline: 'Baseline',
  Postponed_Out: 'Postponed OUT',
  Postponed_In: 'Postponed IN',
  Forecasted: 'Forecasted',
  Validated_Dm: 'Validated DM',
  Refused_Client: 'Refused Client',
  Accepted_Client: 'Accepted Client',
  Invoiced: 'Invoiced',
  // KPI Metrics tab - filter panel toggle button (EDD-424)
  Filter: 'Filter',
  // Financial KPI - income completion table (EDD-424)
  Purchased_Contractual: 'Purchased (contractual)',
  To_Date: 'TO DATE',
  At_Completion: 'At Completion',
  Purchased_Planned: 'Purchased (planned)',
  Tooltip_Purchased_Planned: 'Monthly amount of the Purchase Order defined by sales department.',
  Tooltip_Baseline: 'Amount of the Workunits initially loaded in e-Delivery during the Quote creation.',
  Tooltip_Forecasted: 'Forecast = Baseline - Cancelled + Added - Postponed OUT + Postponed IN',
  Tooltip_Accepted_Client: 'Amount of workunits accepted by the client',
  Tooltip_Invoiced: 'Actual amount invoiced to the customer.',
  Delta_Forecasted_Baseline: 'Delta "Forecasted - Baseline"',
  Delta_Forecasted_Purchased: 'Delta "Forecasted - Purchased"',
  Delta_Invoiced_Purchased: 'Delta "Invoiced - Purchased"',
  // Order card menu (EDD-424)
  Change_Baseline: 'Change Baseline',
  Cancel_Change_Baseline: 'Cancel Change Baseline',
  Download_Excel: 'Download Excel',
  Reopen: 'Reopen',
  // Order card content - dates and progress bars (EDD-424)
  Created_On: 'Created on',
  Modified_On: 'Modified on',
  Realised: 'Realised',
  // Tenant settings - workload page (EDD-424)
  Daily: 'Daily',
  Days: 'Days',
  Hours: 'Hours',
  // Order summary datagrid - display mode & row titles (EDD-424)
  Quarterly: 'Quarterly',
  Daily_Rate: 'Daily Rate',
  Fte: 'FTE',
  // Excel extraction dialogs (EDD-424)
  Excel_Extraction: 'Excel extraction',
  Extract_Excel_Confirm: 'Do you want to extract excel files ?',
  Dont_Extract: "Don't extract",
  Extract: 'Extract',
  Reference_Details: 'Reference Details',
  Spec_Ref: 'Spec Ref',
  Chrono_Ref: 'Chrono Ref',
  // KPI Acceptance page - donut/table/bar chart labels (EDD-424)
  To_Be_Done: 'To be Done',
  Number: 'Number',
  Order_Date_Change_Confirm:
    'You are about to modify the Order date range. Workunits outside the new date range will be cancelled. Do you want to continue?',
  Order_Date_Change_Blocked:
    'The order dates cannot be modified because one or more Workunits within the selected date range have already been submitted.',
  Order_Date_Change_Title: 'Date change restricted',
  Order_Date_Change_Check_Failed: 'Unable to verify submitted workunits. The order dates were not saved.',
  Order_Date_Change_Remove_Failed:
    'Workunits outside the new date range could not be cancelled. The order dates were not saved.',
  Order_Date_Change_Cancel_Reason: 'Order date range modified',
  Order_Date_Change_Save_Failed: 'The order could not be saved. The order dates and workunits were not changed.',
  Order_Date_Change_Restore_Failed:
    'The order dates were not saved, and the cancelled workunits could not be restored. Please restore them from the Deliverables page.',
  // ===== NEW: PopriceDashboard - Orders financial summary table (EDD-424) =====
  Orders: 'Orders',
  Years: 'Years',
  Tooltip_Purchased: 'Amount of the Purchase Order coming from sales department',
  Tooltip_Cancelled: 'Amount of Cancelled Workunits.',
  Tooltip_Added: 'Amount of Added workunits.',
  Tooltip_Submitted: 'Amount of workunits submitted by the consultant.',
  Tooltip_Validated_Dm: 'Amount of workunits validated by the DM.',
  // ===== END NEW =====
};

export default en;
